<div class="edi-document-detail" *ngIf="orderData">

  <lib-gung-tabset #ngbTab="gungTabset" orientation="vertical" [collapsible]="true">
    <header libGungTabsetHeader class="document-page-header">
      <div class="document-identity">
        <span class="document-type">
          <span translate>ORDER_MESSAGE</span>
        </span>
        <h3>{{ orderData.id }}</h3>
        <p *ngIf="orderData.ediConfigId">{{ orderData.ediConfigId }}</p>
      </div>
      <div class="document-page-actions">
        <lib-edi-navigation-buttons [baseRoute]="ediNavigationBaseRoute"></lib-edi-navigation-buttons>
        <lib-edi-send-status class="edi-status-badge" [message]="orderData"></lib-edi-send-status>
        <lib-action-btn [(item)]="orderData" [config]="orderActionConfigService"></lib-action-btn>
      </div>
    </header>
    <lib-gung-tab section="Document" icon="fa-solid fa-file-import" title="Gung internal representation">
      <ng-template libGungTabContent>
        <div class="document-sheet">
          <section class="document-section document-overview">
            <header class="section-heading">
              <div>
                <h4>References and dates</h4>
              </div>
            </header>

            <div class="overview-layout">
              <section class="reference-panel" aria-label="Order references">
                <div class="reference-groups">
                  <section class="reference-group">
                    <header class="reference-group-heading">
                      <div><span>Document references</span></div>
                    </header>
                    <div class="reference-grid">
                      <div class="document-field document-field-primary">
                        <label for="orderMessageId">Message ID</label>
                        <input class="form-control" id="orderMessageId" type="text" [ngModel]="orderData.id" [disabled]="true" />
                      </div>
                      <div class="document-field">
                        <label for="buyerOrderNumber" translate>BUYER_ORDER_NUMBER</label>
                        <input class="form-control" id="buyerOrderNumber" type="text" [ngModel]="orderData.documentReferences.buyerOrder.id" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.documentReferences.buyerOrder.externalId">
                        <label for="orderBuyerExternalId">Buyer order external ID</label>
                        <input class="form-control" id="orderBuyerExternalId" type="text" [ngModel]="orderData.documentReferences.buyerOrder.externalId" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.documentReferences.supplierOrder.id">
                        <label for="supplierOrderNumber" translate>SUPPLIER_ORDER_NUMBER</label>
                        <input class="form-control" id="supplierOrderNumber" type="text" [ngModel]="orderData.documentReferences.supplierOrder.id" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.erpIds?.length">
                        <label>ERP order IDs</label>
                        <div class="document-links">
                          <a *ngFor="let erpId of orderData.erpIds" [routerLink]="['/orders', erpId]">{{ erpId }}</a>
                        </div>
                      </div>
                      <div class="document-field" *ngIf="orderData.documentReferences.supplierOrder.externalId">
                        <label for="orderSupplierExternalId">Supplier order external ID</label>
                        <input class="form-control" id="orderSupplierExternalId" type="text" [ngModel]="orderData.documentReferences.supplierOrder.externalId" [disabled]="true" />
                      </div>
                    </div>
                  </section>

                  <section class="reference-group">
                    <header class="reference-group-heading">
                      <div><span>Timeline</span></div>
                    </header>
                    <div class="reference-grid">
                      <div class="document-field">
                        <label for="orderDate" translate>ORDER_DATE</label>
                        <input class="form-control" id="orderDate" type="text" [ngModel]="orderData.documentReferences.buyerOrder.date" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.documentReferences.supplierOrder.date">
                        <label for="supplierOrderDate">Supplier order date</label>
                        <input class="form-control" id="supplierOrderDate" type="text" [ngModel]="orderData.documentReferences.supplierOrder.date" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.shipmentDate">
                        <label for="orderShipmentDate">Shipment date</label>
                        <input class="form-control" id="orderShipmentDate" type="text" [ngModel]="orderData.shipmentDate" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.deliveryDate">
                        <label for="deliveryDate" translate>DELIVERY_DATE</label>
                        <input class="form-control" id="deliveryDate" type="text" [ngModel]="orderData.deliveryDate" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.timestamp">
                        <label for="timestamp" translate>TIMESTAMP</label>
                        <input class="form-control" id="timestamp" type="text" [ngModel]="orderData.timestamp" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.sentTimestamp">
                        <label for="sentTimestamp" translate>DELIVERED_TIMESTAMP</label>
                        <input class="form-control" id="sentTimestamp" type="text" [ngModel]="orderData.sentTimestamp | date : (dateUtilService.dateFormat + ' HH:mm')" [disabled]="true" />
                      </div>
                    </div>
                  </section>

                  <section class="reference-group">
                    <header class="reference-group-heading">
                      <div><span>Processing</span></div>
                    </header>
                    <div class="reference-grid">
                      <div class="document-field">
                        <label for="orderStatus" translate>GUNG_EDI_MESSAGE_SEND_STATUS</label>
                        <input class="form-control" id="orderStatus" type="text" [ngModel]="orderData.gungEdiMessageSendStatus" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.validationState">
                        <label for="validationState" translate>VALIDATION_STATE</label>
                        <input class="form-control" id="validationState" type="text" [ngModel]="orderData.validationState" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.orderType">
                        <label for="orderType" translate>ORDER_TYPE</label>
                        <input class="form-control" id="orderType" type="text" [ngModel]="orderData.orderType" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.currency">
                        <label for="orderCurrency" translate>CURRENCY</label>
                        <input class="form-control" id="orderCurrency" type="text" [ngModel]="orderData.currency" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.deliveryTermId">
                        <label for="orderDeliveryTerm">Delivery term</label>
                        <input class="form-control" id="orderDeliveryTerm" type="text" [ngModel]="orderData.deliveryTermId" [disabled]="true" />
                      </div>
                      <div class="document-field" *ngIf="orderData.paymentTermText">
                        <label for="orderPaymentTerm">Payment terms</label>
                        <input class="form-control" id="orderPaymentTerm" type="text" [ngModel]="orderData.paymentTermText" [disabled]="true" />
                      </div>
                    </div>
                  </section>
                </div>
              </section>

              <section class="party-panel" aria-label="Order parties">
                <div class="panel-heading">
                  <div><span>Order parties</span></div>
                </div>
                <lib-edi-gln-number-tabs [ediMessage]="orderData" [documentStyle]="true"></lib-edi-gln-number-tabs>
              </section>
            </div>
          </section>

          <lib-edi-detail-error-display [ediMessage]="orderData"></lib-edi-detail-error-display>

          <section class="document-section document-lines">
            <header class="section-heading lines-heading">
              <div><h4><span translate>ORDER_LINES</span></h4></div>
              <span class="line-count">{{ itemCount }} lines · {{ orderSummary.cancelledLineCount }} cancelled · {{ orderSummary.errorLineCount }} with errors</span>
            </header>
            <lib-edi-row-table
              [data]="orderData.items"
              [columns]="itemsColumns"
              [rowClass]="itemRowClass"
              customClass="document-items-table"
            ></lib-edi-row-table>
          </section>

          <section class="document-section document-summary" *ngIf="itemCount || hasDeliveryWindow">
            <header class="section-heading">
              <div><h4>Order summary</h4></div>
            </header>

            <div class="status-summary-grid" *ngIf="itemCount">
              <div class="status-summary-card status-summary-card-positive">
                <strong>{{ orderSummary.activeLineCount }}</strong><span>Active</span>
              </div>
              <div class="status-summary-card status-summary-card-negative">
                <strong>{{ orderSummary.cancelledLineCount }}</strong><span>Cancelled</span>
              </div>
              <div class="status-summary-card status-summary-card-warning">
                <strong>{{ orderSummary.errorLineCount }}</strong><span>With errors</span>
              </div>
              <div class="status-summary-card status-summary-card-neutral">
                <strong>{{ orderSummary.uniqueProductCount }}</strong><span>Products</span>
              </div>
            </div>

            <div class="summary-grid">
              <div class="summary-value-card" *ngFor="let quantity of orderSummary.quantities">
                <span>Ordered quantity</span>
                <strong>{{ formatNumber(quantity.value) }}<small *ngIf="quantity.unit"> {{ quantity.unit }}</small></strong>
              </div>
              <div class="summary-value-card" *ngFor="let amount of orderSummary.amounts">
                <span>Expected net value</span><strong>{{ formatAmount(amount) }}</strong>
              </div>
              <div class="summary-value-card" *ngIf="hasDeliveryWindow">
                <span>Requested delivery</span>
                <strong>
                  {{ orderSummary.earliestDeliveryDate | date : dateUtilService.dateFormat }}
                  <ng-container *ngIf="hasDeliveryDateRange"> – {{ orderSummary.latestDeliveryDate | date : dateUtilService.dateFormat }}</ng-container>
                </strong>
              </div>
            </div>
          </section>
        </div>
      </ng-template>
    </lib-gung-tab>
      <lib-gung-tab section="Related EDI messages" icon="fa-solid fa-reply" [title]="'ORDER_RESPONSES' | translate" *ngIf="orderData.erpIds">
        <ng-template libGungTabContent>
          <lib-edi-related-messages
            kind="ordrsp"
            [relations]="relations"
            [messages]="ordrspMap"
            [toGenerate]="ordrspToGenerate"
            [ediConfigId]="orderData.ediConfigId"
          ></lib-edi-related-messages>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab section="Related EDI messages" icon="fa-solid fa-truck" [title]="'RELATED_EDI_DESADV' | translate" *ngIf="orderData.erpIds">
        <ng-template libGungTabContent>
          <lib-edi-related-messages
            kind="desadv"
            [relations]="relations"
            [messages]="desadvMap"
            [toGenerate]="despachtsToGenerate"
            [ediConfigId]="orderData.ediConfigId"
          ></lib-edi-related-messages>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab section="Related EDI messages" icon="fa-solid fa-file-invoice" [title]="'RELATED_EDI_INVOIC' | translate" *ngIf="orderData.erpIds">
        <ng-template libGungTabContent>
          <lib-edi-related-messages
            kind="invoice"
            [relations]="relations"
            [messages]="invoiceMap"
            [toGenerate]="invoicesToGenerate"
            [ediConfigId]="orderData.ediConfigId"
          ></lib-edi-related-messages>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab
        *ngFor="let erpOrderId of orderData.erpIds"
        section="ERP orders"
        icon="fa-solid fa-boxes-stacked"
        [title]="erpOrderId"
        [link]="['/orders', erpOrderId]"
      ></lib-gung-tab>
      <lib-gung-tab section="External EDI"
        icon="fa-solid fa-file-lines"
        title="External EDI representation"
        *ngIf="orderData.fileNameInclPath && (documentViewerEnabled$ | async)"
      >
        <ng-template libGungTabContent>
          <div class="pt-4">
            <lib-edi-document-viewer
              [messageId]="orderData.id"
              messageType="ORDER"
              [useAi]="true"
            ></lib-edi-document-viewer>
          </div>
        </ng-template>
      </lib-gung-tab>
  </lib-gung-tabset>
</div>
